import script from "./NumberBox.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberBox.vue?vue&type=script&setup=true&lang=js"

import "./NumberBox.vue?vue&type=style&index=0&id=6bb96dcc&lang=css"

const __exports__ = script;

export default __exports__